// extracted by mini-css-extract-plugin
export default {"itemName":"product_itemName__ubjAN","itemPrice":"product_itemPrice__CymsL","soldOut":"product_soldOut__HkJ06","disabledProduct":"product_disabledProduct__4nPob"};